/**
 * @file: The names that the server and the client use for the Curator sync status.
 *
 * The server sends the status as an event and gives each failure a kind. The
 * client shows a text for each kind. Both read the names here, so a new kind
 * or a new event name changes one file.
 */

/** The event that the server sends to every client when the status changes. */
const CURATOR_SYNC_STATUS_EVENT = 'curatorSyncStatusChanged'

/**
 * The kinds of failure. Curator answers 401 for a key that it does not know,
 * and 403 for a plan without API access. All other failures are OTHER.
 */
const CURATOR_FAILURE_KINDS = Object.freeze({
  KEY: 'key',
  PLAN: 'plan',
  OTHER: 'other'
})

export { CURATOR_SYNC_STATUS_EVENT, CURATOR_FAILURE_KINDS }
